"use client";

import { Button } from "@/components/ui/button";
import { Prose } from "@/components/ui/typography";

import { Panel, PanelContent, PanelHeader, PanelTitle } from "./panel";

function CalComButton() {
  return (
    <Button
      asChild
      variant="secondary"
      className="flex-1"
    >
      <a
        href="https://cal.com/sarthak-wd6upi/15min"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2"
      >
        <svg className="size-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
        </svg>
        Schedule Call
      </a>
    </Button>
  );
}

export function IdeaForm() {
  return (
    <Panel id="idea-form">
      <PanelHeader>
        <PanelTitle>Have an Idea?</PanelTitle>
      </PanelHeader>
      <PanelContent className="space-y-4">
        <Prose>
          <p>
            Got a project in mind you&apos;d like to see come to life? I&apos;m
            always excited to explore new ideas.
          </p>
        </Prose>

        <div className="space-y-3">
          <div className="flex flex-col gap-3 sm:flex-row">
            <Button
              asChild
              variant="default"
              className="flex-1"
            >
              <a
                href="https://x.com/Sarthakhuh"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2"
              >
                <svg className="size-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
                Message on X
              </a>
            </Button>

            <CalComButton />
          </div>
        </div>
      </PanelContent>
    </Panel>
  );
}
